// extracted by mini-css-extract-plugin
export var avatar = "_ob-3";
export var avatarContainer = "_ob-2";
export var avatarSpacer = "_ob-5";
export var avatarSpacerContainer = "_ob-4";
export var avatarStackContainer = "_ob-1";
export var bubble = "_ob-0";
export var remainderBubble = "_ob-6";